@for (toast of wdxToastService.toasts; track $index) {
    @if (toast.header | wdxToastHeaderIsTemplate) {
        <ngb-toast
            [autohide]="toast.autohide"
            [ngClass]="
                (toast.severity ? 'toast-' + toast.severity : '') +
                (toast.classname ? ' ' + toast.classname : '')
            "
            [delay]="toast.delay || DEFAULT_CLOSE_DELAY_MS"
            (hidden)="wdxToastService.remove(toast)"
            (mouseenter)="toast.autohide = false"
            (mouseleave)="toast.autohide = true"
        >
            <ng-template ngbToastHeader>
                <div class="flex-1">
                    <ng-container
                        *ngTemplateOutlet="
                            $any(toast).header;
                            context: getTemplateContext(toast)
                        "
                    ></ng-container>
                </div>
            </ng-template>
            <ng-container
                *ngTemplateOutlet="
                    toastContentTemplate;
                    context: { $implicit: toast }
                "
            ></ng-container>
        </ngb-toast>
    } @else {
        <ngb-toast
            [autohide]="toast.autohide"
            [header]="toast.header | wdxToastHeaderText"
            [ngClass]="
                (toast.severity ? 'toast-' + toast.severity : '') +
                (toast.classname ? ' ' + toast.classname : '')
            "
            [delay]="toast.delay || DEFAULT_CLOSE_DELAY_MS"
            (hidden)="wdxToastService.remove(toast)"
            (mouseenter)="toast.autohide = false"
            (mouseleave)="toast.autohide = true"
        >
            <ng-container
                *ngTemplateOutlet="
                    toastContentTemplate;
                    context: { $implicit: toast }
                "
            ></ng-container>
        </ngb-toast>
    }
}

<ng-template #toastContentTemplate let-toast>
    <div class="d-flex align-items-center">
        <div class="flex-grow-1">
            @if (toast.isTemplate) {
                <ng-container
                    *ngTemplateOutlet="
                        $any(toast).body;
                        context: getTemplateContext(toast)
                    "
                ></ng-container>
            } @else {
                <ng-container
                    *ngTemplateOutlet="
                        toastTextBodyTemplate;
                        context: { $implicit: toast }
                    "
                ></ng-container>
            }
        </div>
        @if (!toast.hideCloseOnBody && !toast.header) {
            <div class="flex-shrink-0 align-self-start">
                <wdx-icon-button
                    class="ms-4"
                    data-cy="wdx-toast-close-btn"
                    aria-label="Close"
                    [severity]="toast.severity"
                    (wdxOnClick)="wdxToastService.remove(toast)"
                >
                    <wdx-icon icon="times"></wdx-icon>
                </wdx-icon-button>
            </div>
        }
    </div>
</ng-template>

<ng-template #toastTextBodyTemplate let-toast>
    <div class="d-flex align-items-center">
        @if (!toast.header) {
            @if (toast.throbber) {
                <wdx-spinner
                    class="toast-throbber d-block position-relative me-2"
                    [themeColor]="toast.themeColor!"
                    [small]="true"
                ></wdx-spinner>
            }
            @if (!toast.throbber && toast.severity) {
                <wdx-icon
                    class="icon-shift-down align-self-start me-1"
                    [icon]="toast.icon"
                    [fixedWidth]="true"
                ></wdx-icon>
            }
        }
        <div>
            @for (line of $any(toast).body; track $index) {
                @if (toast.bodyRouterLink) {
                    <a
                        class="text-decoration-underline"
                        data-cy="wdx-toast-link"
                        [routerLink]="toast.bodyRouterLink"
                        [queryParams]="toast.bodyQueryParams"
                    >
                        {{ line }}
                    </a>
                }
                @if (!toast.bodyRouterLink) {
                    <div
                        data-cy="wdx-toast-text"
                        [innerHTML]="
                            line
                                | translateTokenisedString
                                | markdownToHtml
                                | safeHtml
                        "
                    ></div>
                }
            }
        </div>
    </div>
</ng-template>
